import React from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[#1a1a1a] pt-6 mt-10">
      <div className="container-x grid gap-4 lg:gap-20 grid-cols-1 md:grid-cols-4 lg:justify-items-end ">
        <div>
          <Link to="/" className="font-[Sora] font-black tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-[#D4FF00] to-white">
            <img src="/images/logotest.png" alt="Gaming Cafe" className="w-[250px]" />
          </Link>
          <p className="text-neutral-400 mt-2 text-sm">© {year} Revelstoke Gaming Cafe</p>
        </div>
        <div className="flex flex-col gap-2">
          <h4 className="font-bold mb-1 text-accent ">Visit</h4>
          <p className="text-sm hover:text-accent duration-150 ease-in transition-colors"><a href="https://maps.app.goo.gl/ZRkuPNw7qNczx1mr6" target="_blank">103 2 St E Downstairs, Revelstoke, BC V0E 2S0, Canada</a></p>
          <p className="text-sm">Open Mon - Fri • 11:00am – 5:00pm</p>
        </div>
        <div className="flex flex-col">
          <h4 className="font-bold mb-1 text-accent">Contact</h4>
          <p><Link className="hover:text-accent text-sm transition:hover duration-150 ease-in" to="mailto:hello@rgc.example ">info@revytech.ca</Link></p>
          <p><Link className="hover:text-accent text-sm transition:hover duration-150 ease-in" to="tel:+12508146000">+1 (250) 814-6000</Link></p>
        </div>
        <div>
          <h4 className="font-bold mb-1 text-accent">Links</h4>
          <p><Link to="/pricing" className="text-white text-sm hover:text-accent duration-150 ease-in transition-colors">
            Pricing
          </Link></p>

          {/* root page section */}
          <p><Link to={{ pathname: "/", hash: "#faq" }} className="text-white text-sm hover:text-accent duration-150 ease-in transition-colors">
            FAQ
          </Link></p>

          <p><Link to="/contact" className="text-white text-sm hover:text-accent duration-150 ease-in transition-colors">
            Contact
          </Link></p>
        </div>
      </div>
      <div className="border-t border-[#1a1a1a] mt-6 py-4 text-center text-neutral-400">
        <Link to="/policies" className="mx-2 text-sm hover:text-white">Policies</Link>
        <Link to="/terms" className="mx-2 text-sm hover:text-white">Terms</Link>
        <Link to="/login" className="mx-2 text-sm hover:text-white">Admin</Link>
      </div>
    </footer>
  );
}
